export const API_RESPONSE_CONTACT_US = 'contact_us'
export const API_RESPONSE_NOT_FOUND = 'address_not_found'
export const API_RESPONSE_NOT_AVAILABLE = 'not_available'
export const API_RESPONSE_AVAILABLE = 'available'

export const GA_EVENT_CATEGORY = 'Address Check'

export const POLL_INTERVAL = 3000 // in milliseconds



// WEBPACK FOOTER //
// ./containers/stages/AddressCheckStage/constants.js